// extracted by mini-css-extract-plugin
export default {"answer":"dealname_answer__e8WkD","answers_row":"dealname_answers_row__h222o","description":"dealname_description__Qaz3z"};